'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

exports.default = createHasSubmitFailed;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/hasSubmitFailed.js
// module id = 411
// module chunks = 0